<template>
  <div class="salesman-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入手机号/姓名查找"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
  </div>
</template>
    
    <script>

export default {
  name: "salesman-list",
  data () {

    return {
      id: null, // 页面agentid
      loading: true,
      dataloading: true,
      title: "信息",
      isable: false,
      agents: {},

      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "ID",
          key: "id",
          width: 150
        },
        {
          title: "编码号",
          key: "qrcode_num",
          width: 120,
        },
        {
          title: "分销商",
          key: "agent_name",
          width: 120,
        },
        {
          title: "创建时间",
          key: "created_at",
          width: 150,
        }
      ],
      tablelist: [],
    };
  },
  created: function () {
    this.uuid = this.$route.params.uuid;
    this.getTableList();
  },
  components: {
  },
  watch: {
    "$route.params.uuid": function (curVal, oldVal) {
      if (curVal) {
        this.uuid = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function () {
      this.$api.salesman
        .saomalog({
          page: this.pages.page,
          size: this.pages.size,
          uuid: this.uuid
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        uuid: this.uuid
      };
      this.$api.salesman.saomalog(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  }
};
    </script>
    

  
